import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Space, message, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import PermissionModalContent from './PermissionModalContent';
import { getPermissions, addPermission, updatePermission, deletePermission } from '../../../utils/api';

const PermissionsTable = () => {
  const [data, setData] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [currentPermission, setCurrentPermission] = useState(null);

  const fetchAllPermissions = async () => {
    try {
      setDataLoading(true);
      const res = await getPermissions();
      setData(res.data.data || []);
    } catch (err) {
      message.error('Error fetching Permissions!');
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    fetchAllPermissions();
  }, []);

  const handleCreate = async (values) => {
    try {
      await addPermission(values);
      await fetchAllPermissions();
      setCreateModalOpen(false);
    } catch (err) {
      message.error('Error creating Permission!');
    }
  };

  const handleUpdate = async (id, values) => {
    try {
      await updatePermission(id, values);
      await fetchAllPermissions();
      setEditModalOpen(false);
      setCurrentPermission(null);
    } catch (err) {
      message.error('Error updating Permission!');
    }
  };

  const handleDelete = async (id) => {
    try {
      await deletePermission(id);
      await fetchAllPermissions();
    } catch (err) {
      message.error('Error deleting Permission!');
    }
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Display Name',
      dataIndex: 'display_name',
      key: 'display_name',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space>
          <EditOutlined
            className='cursor-pointer'
            onClick={() => {
              setCurrentPermission(record);
              setEditModalOpen(true);
            }}
          />
          <Popconfirm
            title="Are you sure to delete this permission?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <DeleteOutlined className='cursor-pointer text-dangerRed' />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <div className='flex justify-end mb-4'>
        <Button type='primary' onClick={() => setCreateModalOpen(true)}>
          Create Permission
        </Button>
      </div>
      <Table dataSource={data} columns={columns} loading={dataLoading} rowKey="id" />
      <Modal
        title="Create Permission"
        open={createModalOpen}
        footer={null}
        onCancel={() => setCreateModalOpen(false)}
      >
        <PermissionModalContent onSubmit={handleCreate} onCancel={() => setCreateModalOpen(false)} />
      </Modal>

      <Modal
        title="Edit Permission"
        open={editModalOpen}
        footer={null}
        onCancel={() => {
          setEditModalOpen(false);
          setCurrentPermission(null);
        }}
      >
        <PermissionModalContent
          initialData={currentPermission}
          onSubmit={(values) => handleUpdate(currentPermission.id, values)}
          onCancel={() => {
            setEditModalOpen(false);
            setCurrentPermission(null);
          }}
        />
      </Modal>
    </>
  );
};

export default PermissionsTable;
